export default __webpack_public_path__ + "static/media/Botswana.7eafbd27.png";